exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feature__pills[data-v-dcfb134c]{display:flex;flex-wrap:wrap;list-style:none;padding:0 20px 20px 0}.feature__pills-pill[data-v-dcfb134c]{display:inline-flex;box-shadow:none!important;display:inline-block;background-color:hsla(0,0%,100%,.9);border:2px solid hsla(0,0%,55%,.3);color:#adadad;border-radius:25px;white-space:nowrap;margin:3px 0;user-select:none;transition:all .2s;padding:4px 8px;cursor:pointer;margin-right:2px;font-size:14px}.selected[data-v-dcfb134c]{border:2px solid rgba(67,146,206,.3);background-color:rgba(67,146,206,.3);color:#333}.feature-add[data-v-dcfb134c]{border:2px solid rgba(0,159,0,.3);background-color:rgba(0,159,0,.3);color:#333}.feature-remove[data-v-dcfb134c]{border:2px solid rgba(220,53,69,.3);background-color:rgba(220,53,69,.3);color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-dcfb134c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/property-qc/TagPills.vue
// module id = 824
// module chunks = 0